module.exports = __webpack_public_path__ + "static/img/title.9fe8ac15.png";